import { render, staticRenderFns } from "./About-App.vue?vue&type=template&id=1015c8d0&"
import script from "./About-App.vue?vue&type=script&lang=js&"
export * from "./About-App.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports